// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._wrapper_drawer_1y76z_1 {
  --perxis-auto-drawer-body-padding: 0px;
  --perxis-auto-drawer-width-xxl: 100vw;
  --perxis-auto-drawer-width-lg: 100vw;
  --perxis-auto-drawer-width-md: 100vw;
  --perxis-auto-drawer-width-sm: 100vw;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
